import { DriverService } from './../../../services/driver.service';
import { SearchService } from 'src/app/services/search.service';
import { Customer } from './../../../models/Customer';
import { AuthService } from './../../../services/auth.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { LocationLevel, LocationModel } from 'src/app/models/Location/LocationModel';
import { CustomerSummaryModel } from 'src/app/models/Profile/CustomerSummaryModel';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import 'moment/locale/ar';

@Component({
  selector: 'driver',
  templateUrl: './driver.component.html',
  styleUrls: ['./driver.component.css'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})




export class DriverComponent implements OnInit {
  primaryEmail;
  selectedLang: any;
  @Input() driverData: any;
  driverInfoForm: FormGroup;
  submitted = false;
  customer: Customer;
  @Input() stepper: MatStepper;
  currentCustomerEmail: any;
  emailOldVal: string = "";
  minDOB: Date = new Date();
  @Input() saveAndConfirmMsg: string;


  //#region  Location Variables/Getters
  locationsRoot: LocationModel[];
  locationLevels: LocationLevel[];
  selectedLevels = {};
  selectedRoot: LocationModel;
  customerProfile: CustomerSummaryModel;

  get locationLevelsDropDown() {
    if (this.locationLevels == null)
      return null
    return this.locationLevels.filter(a => a.isRootLevel != true);
  }

  //#endregion

  constructor(private formBuilder: FormBuilder, private authService: AuthService, private searchService: SearchService, private driverService: DriverService, private _adapter: DateAdapter<any>) { }
  selectedCountryISO = CountryISO.UnitedStates;
  faTimesCircle = faTimesCircle;



  ngOnInit() {
    this.minDOB.setFullYear(this.minDOB.getFullYear() - 18);

    this.driverData.subscribe(res => {

      this.driverInfoForm = res;
    });
    // this.searchService.getCountryCodeFromIP().subscribe(res =>{
    //   if(res!=null&&res['countryCode']!=null){
    //     this.selectedCountryISO=res['countryCode'];
    //   }
    // })
    this.authService.loggedInCustomer.subscribe(res => {

      if (res != null) {
        this.customer = res;
        this.primaryEmail = res.primaryEmail;
        //this.currentCustomerEmail=res.primaryEmail;

        this.authService.getCustomerSummary(this.customer.customerID).subscribe(res => {

          //Use the latest info for the user.
          this.initlizeForm({
            firstName: res.firstName,
            secondName: res.secondName,
            thirdName: res.familyName,
            DateofBirth: res.dob,
            email: res.primaryEmail,
            mobileNum: res.mobile1
          })

          this.customerProfile = res;
          this.authService.getCustomerLocation(null).subscribe(res => {

            this.driverInfoForm.addControl("country", new FormControl(null, Validators.required));
            this.driverInfoForm.addControl("locationID", new FormControl());

            this.locationsRoot = res;

            if (this.customerProfile != null && this.customerProfile.locationDetails != null) {
              let rootLevel = this.customerProfile.locationDetails.filter(a => a.isRootLevel == true)[0];

              if (rootLevel != null) {
                let result = this.locationsRoot.filter(a => a.locationID == rootLevel.locationID)[0];
                if (result != null) {
                  //result.isSelected=true;
                  this.selectedRoot = result;
                  this.driverInfoForm.controls['country'].setValue(result);
                  this.buildLocations(result);
                }
              }
            }

          })
        })

      }
      else {
        let _cachedCustomer = JSON.parse(this.authService.GetCustomerStorage());
        if (_cachedCustomer != null) {
          this.authService.saveCustomer(_cachedCustomer);

        }
        //Here should be logged in
        //No default value initalization
        else {
          this.initlizeForm({
            firstName: '',
            secondName: '',
            thirdName: '',
            DateofBirth: '',
            email: '',
            mobileNum: ''
          });
        }

      }



    });


    // This is For changing language for the calendar
    this.selectedLang = JSON.parse(localStorage.getItem("lang"));
    switch (this.selectedLang.isoCode2) {
      case "en":
        this._adapter.setLocale('en-US');
        break;
      case "ar":
        this._adapter.setLocale('ar-ly');
        break;
      default:
        this._adapter.setLocale('en-US');
        break;
    }




  }

  initlizeForm(model) {
    this.driverInfoForm = this.formBuilder.group({
      firstName: [model.firstName, Validators.required],
      secondName: [model.secondName, Validators.required],
      thirdName: [model.thirdName, Validators.required],
      DateofBirth: [model.DateofBirth, Validators.required],
      email: [model.email, [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?:[a-zA-Z]{2}|aero|asia|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel)$")]],
      //mobileCode: [model.mobileCode, Validators.required],
      mobileNum: [model.mobileNum, Validators.required],
    });
  }

  // convenience getter for easy access to form fields
  get driverInfo() { return this.driverInfoForm != null ? this.driverInfoForm.controls : this.driverInfoForm; }

  onSubmit() {

    this.submitted = true;


    this.driverInfoForm.controls.mobileNum.setErrors({ 'InvalidSpace': null });
    this.driverInfoForm.controls.mobileNum.setErrors({ 'RequiredCountryCode': null });
    this.driverInfoForm.controls.mobileNum.updateValueAndValidity();

    //custom Validation for Mobile number, Incase it have spaces
    let countryControlVal = this.driverInfoForm.controls.mobileNum.value;
    if (countryControlVal != null && countryControlVal.number.includes(' ')) {
      this.driverInfoForm.controls.mobileNum.setErrors({ 'InvalidSpace': 'invalidPhoneNumber' });
      //this.driverInfoForm.controls.mobileNum.updateValueAndValidity();
      return;
    }
    if (countryControlVal != null && !countryControlVal.number.includes(countryControlVal.dialCode)) {
      this.driverInfoForm.controls.mobileNum.setErrors({ 'RequiredCountryCode': 'invalidPhoneNumber' });
      //this.driverInfoForm.controls.mobileNum.updateValueAndValidity();
      return;
    }


    // stop here if form is invalid
    if (this.driverInfoForm.invalid) {//this.driverInfoForm.invalid
      return;
    }


    this.fetchCustomerFromForm();


    // display form values on success
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.driverInfoForm.value, null, 4));
    this.driverData.next(new FormGroup(this.driverInfoForm.controls));



  }
  fetchCustomerFromForm() {
    this.customer.firstName = this.driverInfoForm.controls['firstName'].value;
    this.customer.secondName = this.driverInfoForm.controls['secondName'].value;
    this.customer.familyName = this.driverInfoForm.controls['thirdName'].value;
    this.customer.dob = this.driverInfoForm.controls['DateofBirth'].value;
    this.customer.mobile1 = this.driverInfoForm.controls['mobileNum'].value.number;
    this.customer.primaryEmail = this.driverInfoForm.controls['email'].value;

    let locationLevel = this.locationLevels != null ? this.locationLevels.filter(a => a.isLastLevel == true)[0] : null;
    if (locationLevel != null) {
      if (this.selectedLevels[locationLevel.locationLevelID] != null) {
        this.customer.locationID = this.selectedLevels[locationLevel.locationLevelID].locationID;
        this.driverInfoForm.controls["locationID"].setValue(this.customer.locationID);
        this.driverInfoForm.controls["locationID"].setValidators(Validators.required);
        this.driverInfoForm.controls["locationID"].updateValueAndValidity();
      }
    }
  }

  onReset() {
    this.submitted = false;
    this.driverInfoForm.reset();
  }

  mobileNumCountryCodeChanged() {
    this.driverInfoForm.controls['mobileNum'].setValue(null);
  }

  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });

  changePreferredCountries() {
    this.preferredCountries = [CountryISO.India, CountryISO.Canada];
  }
  /*   emilBlur(event){
      let val=event.target.value;
      if(val==this.currentCustomerEmail){
        return
      }
      if(val !=null && val!="" && val != this.emailOldVal){
        this.emailOldVal=val;
        this.authService.checkIfEmailExist(val).subscribe(res => {

          if(res){
            this.driverInfoForm.controls['email']?.setErrors({'exist': 'Email Already Exist'});
          }
          else{
            this.driverInfoForm.controls['email']?.setErrors({'exist': null});
          }
        })

      }
    } */

  // emilBlur(event){

  //   let val=event.target.value
  //   if(val !=null && val!="" && val!=this.customer.primaryEmail){
  //     val=(val as string).trim();
  //     let errors=this.driverInfoForm.controls['email'].errors;
  //     if(  errors==null){

  //       this.emailOldVal=val;
  //       this.authService.checkIfEmailExist(val).subscribe(res => {

  //         if(res){
  //           this.driverInfoForm.controls['email']?.setErrors({'exist': 'Email Already Exist'});
  //         }
  //         else{
  //           this.driverInfoForm.controls['email']?.setErrors(null);
  //         }
  //       })

  //     }
  //   }

  // }

  //#region  Location Methods

  buildLocations(locations: LocationModel) {

    //Remove the old Drop Downs Form Control data
    if (this.locationLevels != null) {
      let subLocations = this.locationLevels.filter(a => !a.isRootLevel);
      subLocations.forEach(element => {
        this.driverInfoForm.removeControl(element.locationLevelID.toString());
      });
    }

    this.locationLevels = locations.locationLevel;


    //Create new Drop Downs Form Control for the new data
    let subLocations = this.locationLevels.filter(a => !a.isRootLevel);
    subLocations.forEach(element => {
      this.driverInfoForm.addControl(element.locationLevelID.toString(), new FormControl(null, Validators.required));
    });

    let rootLocationID = this.locationLevels.filter(a => a.isRootLevel == true)[0];
    let childLevel = this.locationLevels.filter(a => a.parentID == rootLocationID.locationLevelID)[0];
    this.authService.getCustomerLocation(locations.locationID).subscribe(res => {
      childLevel.locationLevelData = res;
      childLevel.locationLevelData.forEach(item => {
        if (this.isLocationDropDownSelected(item)) {
          item.isSelected = true;
          this.selectedLevels[item.locationLevelID] = item;
          this.driverInfoForm.controls[item.locationLevelID + ''].setValue(item);
          this.driverInfoForm.controls[item.locationLevelID + ''].setValidators(Validators.required);
          this.getLocationLevelDynamic(item);
        }
      })
    });

  }
  getLocationLevelDynamic(location: LocationModel) {


    this.clearChildLevelsData(location);
    let childLevel = this.locationLevels.filter(a => a.parentID == location.locationLevelID)[0];
    if (childLevel != null) {
      this.authService.getCustomerLocation(location.locationID).subscribe(res => {
        childLevel.locationLevelData = res;
        childLevel.locationLevelData.forEach(item => {
          if (this.isLocationDropDownSelected(item)) {
            item.isSelected = true;
            this.selectedLevels[item.locationLevelID] = item;
            this.driverInfoForm.controls[item.locationLevelID + ''].setValue(item);
            this.getLocationLevelDynamic(item);
          }
        })

      });
    }
  }
  clearChildLevelsData(location: LocationModel) {
    this.clearChildsRecersion(location.locationLevelID);

  }
  clearChildsRecersion(locationID) {
    let _location = this.locationLevels.filter(a => a.parentID == locationID)[0];
    if (_location != null) {
      _location.locationLevelData = null;
      this.driverInfoForm.controls[_location.locationLevelID + ''].setValue(null);
      this.clearChildsRecersion(_location.locationLevelID);
    }
    else {
      return;
    }


  }
  isLocationDropDownSelected(location: LocationModel) {

    if (this.customerProfile != null && this.customerProfile.locationDetails != null) {
      let locationDetails = this.customerProfile.locationDetails;
      let res = locationDetails.filter(a => a.locationLevelID == location.locationLevelID && a.locationID == location.locationID);
      if (res != null && res.length > 0) {
        return true;
      }
    }
    return false;
  }
  getSelectedLevelLocationID(childLevel: LocationLevel) {
    if (this.customerProfile != null && this.customerProfile.locationDetails != null) {
      let locationDetails = this.customerProfile.locationDetails;
      let res = locationDetails.filter(a => a.locationLevelID == childLevel.locationLevelID)[0];
      if (res != null) {
        let location: LocationModel = {
          locationID: res.locationID,
          locationLevelID: res.locationLevelID
        }
        return location;
      }
    }
    return null;
  }

  //#endregion


  addEvent(mode: number, type: string, event: MatDatepickerInputEvent<Date>) {
    this.driverService.updateDriverAge(event.value);

  }

}
